module.exports = __webpack_public_path__ + "img/Linkedin.6e27fb4f.svg";